import App from './App';
import React from 'react';
import { hydrate, render } from 'react-dom';

import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import GameStore from './store/Games';
import AuthStore from './store/Auth';

import http from './http';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { CookiesProvider } from 'react-cookie';
import { prepareCssVar100vh } from './common';

// import LogRocket from 'logrocket';
// LogRocket.init('rl6gff/tgl-dev-game');

// handling 401 status code
http.interceptors.response.use(null, error => {
  const resp = error?.response
  if (resp) {
    if (resp.status === 401) {
      const auth = store.getState().auth;
      if (auth.isAuthenticated) {
        console.log('try refreshing token')
        const p = auth.isLoading // prevent multiple requests
          ? auth.promise // wait for previous request
          : store.dispatch(AuthStore.actionCreators.refresh()) // refresh token
            .then((resp) => {
              delete error.config.headers.Authorization;
              return resp
            })
        // rerun request
        return p.then(() => {
          return http.request(error.config)
        });
      }
    }
  }

  throw error
})

// Create browser history to use in the Redux store
// const baseUrl = document.getElementsByTagName('base')[0]?.href;
const history = createBrowserHistory();

// Get the application-wide store instance, prepopulating with state from the server where available.
const _window = typeof window != 'undefined' ? window : null;
const initialState = _window?.__STATE__ ?? undefined;
const store = configureStore(history, initialState);

store.dispatch(GameStore.actionCreators.checkVersion())

// if(typeof window != 'undefined' && window.navigator?.virtualKeyboard) {
//   window.navigator.virtualKeyboard.overlaysContent = true; // ONLY WORKS USING CHROME??
// }
prepareCssVar100vh()

const renderer = module.hot ? render : hydrate
// loadableReady().then(() => {
renderer(
  <CookiesProvider>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </Provider>
  </CookiesProvider>,
  document.getElementById('root')
);
// })

// serviceWorkerRegistration.register();

if (module.hot) {
  module.hot.accept();
}
